<template>
  <div v-if="filters && filters.length > 0" class="is-flex">
    <div style="margin: 20px 0 10px 30px;" v-for="filter in filters" :key="filter.designator">
      <a @click="onClick(filter)" class="filter button" :class="[filter.class ? filter.class : '', data[filter.designator].length ? 'is-info' : 'is-danger pale']">{{ data[filter.designator].length ? data[filter.designator].map(e => e.text).join(',') : (filter.label || filter.designator) }}</a>
    </div>
  </div>
</template>
<script>
import { mapMutations } from 'vuex'
export default {
  name: 'filters-modal-button',
  props: ['filters'],
  data () {
    return {
      data: {}
    }
  },
  watch: {
    filters: {
      handler: function () {
        this.filters.forEach(filter => {
          const selected = this.initSelected(filter)
          this.data[filter.designator] = selected
        })
      },
      deep: true
    }
  },
  created () {
    this.filters.forEach(filter => {
      this.$set(this.data, filter.designator, [])
    })
  },
  methods: {
    initSelected (filter) {
      return (this.$route.query[filter.designator] || '').split(filter.splitter || ',').map(el => {
        if (filter.options) {
          return filter.options.find(option => option.value == el)
        }
        if (el && filter.subType == 'min-max-experience') {
          return { text: el }
        }
        if (el && filter.subType == 'min-max-seniority') {
          return { text: el }
        }
      }).filter(el => el)
    },
    onClick (filter) {
      let subType = ''
      let title = ''
      switch (filter.subType || '') {
        case 'min-max':
          subType = 'FilterInputRange'
          title = 'Year range filter'
          break
        case 'min-max-experience':
          subType = 'FilterMinMaxExperienceInputRange'
          title = 'Experience range filter'
          break
        case 'min-max-seniority':
          subType = 'FilterMinMaxExperienceInputRange'
          title = 'Certification/Seniority range filter'
          break
        default:
          subType = 'FilterMultiple'
          title = 'Multi-Selection'
      }
      this.create({
        designator: filter.designator,
        component_name: subType,
        is_modal: true,
        options: filter.options,
        splitter: filter.splitter,
        modal_title: title,
        grouped: filter.grouped,
        searchable: filter.searchable
      })
    },
    ...mapMutations('modals', ['create'])
  }
}
</script>
<style scoped>
.pale {
  opacity: 0.5;
}
</style>
